import { useState } from "react";
import styled from "styled-components";
import { convertToSlug, media } from "../../utils/helper";
import ErrorIcon from "../../assets/svgIcons/ErrorIcon";
import StyledText from "./StyledText";
import WarningIcon from "../../assets/svgIcons/WarningIcon";
import ViewPassword from "../ViewPassword";

const StyledInput = ({
  label,
  value,
  onChange,
  type = "text",
  placeholder,
  isSubmitted,
  error,
  ...props
}) => {
  const [focused, setFocused] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleFocus = () => {
    setFocused(true);
  };

  const handleBlur = () => {
    setFocused(false);
  };

  return (
    <StyledContainer className="input-main-container w-100 d-flex gap-1 flex-column">
      <StyledInputContainer
        className={`custom-input-container ${focused ? "focused" : ""} ${error ? " invalid " : ""}`}
      >
        {label && (
          <label className={`custom-label ${focused ? "focused" : ""}`}>
            {label} {props.required && (<span className="required">*</span>)}
          </label>
        )}

        <input
          data-testid={convertToSlug(label || placeholder)}
          placeholder={placeholder}
          type={type === "password" ? (showPassword ? 'text' : 'password') : type}
          value={value}
          onChange={onChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          {...props}
        />
        <span className="error-icon">
          <ErrorIcon />
        </span>
        {type === "password" && <ViewPassword error={error} showPassword={showPassword} setShowPassword={setShowPassword} />}
      </StyledInputContainer>
      {error && (
        <div className="pt-1">
          <WarningIcon />
          <StyledText $fontSize="14px" color="danger" className="ps-1 text-start align-middle">
            {error}
          </StyledText>
        </div>
      )}
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  margin-bottom: 20px;
  ${media.md`
        margin-bottom: 15px;
  `}
`;
const StyledInputContainer = styled.div`
  position: relative;

  .custom-label {
    position: absolute;
    left: 13px;
    top: 22%;
    transform: translateY(-23%);
    transition: all 0.3s;
    pointer-events: none;
    color: ${({ theme }) => theme.colors.primaryLight};
    font-size: 12px;
    font-weight: 500;
  }

  .error-icon {
    display: none;
  }

  &.focused .custom-label,
  input:valid + .custom-label {
    color: ${({ theme }) => theme.colors.primary};
  }

  input {
    width: 100%;
    padding: 30px 10px 15px 10px;
    border: 1.5px solid ${({ theme }) => theme.colors.borderColor};
    border-radius: 5px;
    outline: none;
    font-size: 14px;

    ${media.md`
         padding: 28px 10px 10px 12px;
    `}
  }

  &.invalid {
    input {
      border-color: ${({ theme }) => theme.colors.danger};
      color: ${({ theme }) => theme.colors.danger};
    }

    .custom-label {
      color: ${({ theme }) => theme.colors.danger};
    }

    .error-icon {
      display: block;
      position: absolute;
      right: 14px;
      top: 30%;
    }
  }

  .focused input {
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;
export default StyledInput;
